import { useState, useEffect } from "react";
import { vendorFieldsMapping } from '../../../../Constants/Data';
import { updateInformation } from '../../../API_Handler';
import { useNavigate } from 'react-router-dom';

const VendorModal = ({ selectedVendor, backgroundColor, vendorProducts }) => {
    const navigate = useNavigate();
    const [vendor, setVendor] = useState(selectedVendor);
    const [editedVendor, setEditedVendor] = useState(selectedVendor);
    const [expandedVendor, setExpandedVendor] = useState(false);
    const [error, setError] = useState(false);
    const [editing, setEditing] = useState(false);
    const [loading, setLoading] = useState(false);
    const [confirmation, setConfirmation] = useState(false);

    const [save, setSave] = useState(false);
    const [cancel, setCancel] = useState(false);

    const handleChangeVendorApprovalStatus = async (status) => {
        setLoading(true);
        let success = await updateInformation(selectedVendor.id, { approval_status: status });
        if (success != null) {
            setLoading(false);
            setChangedFields({});
            setVendor(success);
            setEditedVendor(success);
        } else {
            setError(true);
        }
    }

    const [changedFields, setChangedFields] = useState({});

    const getChangedFields = () => {
        const changes = {};
        for (const key in vendor) {
            if (vendor[key] !== editedVendor[key]) {
                changes[key] = editedVendor[key];
            }
        }
        return changes;
    }

    const handleSave = async () => {
        const changes = await getChangedFields();
        setChangedFields(changes);
        if (Object.keys(changes).length > 0) {
            setConfirmation(true);
            setSave(true);
        }
        setEditing(false);
    }

    const handleCancel = async () => {
        const changes = await getChangedFields();
        setChangedFields(changes);
        if (Object.keys(changes).length > 0) {
            setConfirmation(true);
            setCancel(true);
        }
        setEditing(false);
    }

    const handleConfirm = async () => {
        setLoading(true);
        let changedFields = await getChangedFields();
        let success = await updateInformation(selectedVendor.id, changedFields);
        if (success != null) {
            setVendor(success);
            setEditedVendor(success);
            setSave(false);
            setConfirmation(false);
            setEditing(false);
        }
        else {
            setSave(false);
            setError(true);
        }
        setLoading(false);
    }

    const handleDiscard = async () => {
        setEditedVendor(vendor);
        setConfirmation(false);
        setSave(false);
        setCancel(false);
        setEditing(false);
    }


    return (
        <div className={`w-full h-fit ${expandedVendor ? "bg-[#fff6e7]" : backgroundColor} flex flex-col border-[1px] ${expandedVendor ? "border-charmOrange" : "border-transparent"}`}>
            <div className={`w-full ${expandedVendor ? "bg-[#fff6e7]" : backgroundColor} px-[16px] py-[1px] flex flex-row justify-between items-center ${expandedVendor ? "border-b-[1px] border-[#a0a0a0]" : ""}   hover:bg-[#fff6e7]`}>
                <p className="min-w-[60px] max-w-[60px] pr-[16px] font-proximanova text-[18px] text-[#505050] font-[500] border-r-[1px] border-[#a0a0a0] mb-0 cursor-pointer"
                    onClick={() => setExpandedVendor(!expandedVendor)} >
                    {vendor.id}</p>

                <p className="w-full pl-[16px] font-proximanova text-[18px] text-[#505050] text-left font-[500] mb-0 cursor-pointer"
                    onClick={() => setExpandedVendor(!expandedVendor)}
                >
                    {vendor.company_name}
                </p>

                <div className="flex flex-row justify-between">
                    <div className="w-[140px] flex flex-row items-center border-l-[1px] pl-[16px] border-[#a0a0a0] gap-[8px]">
                        <div className={`w-[8px] h-[8px] rounded-full ${vendor.approval_status === "PENDING" ? 'bg-[#bbbbbb]' : vendor.approval_status === "APPROVED" ? 'bg-[#76da24]' : vendor.approval_status === "REJECTED" ? 'bg-[#fd5764]' : ''} `}></div>
                        <p className="w-fit font-proximanova text-[18px] text-[#505050] font-[500] mb-0">{vendor.approval_status}</p>
                    </div>

                    <div className="min-w-[80px] max-w-[80px] border-l-[1px] pl-[16px] border-[#a0a0a0] flex flex-row items-center justify-center">
                        {expandedVendor === false ?
                            (
                                <button className="w-fit flex flex-row items-center justify-center font-proximanova text-charmOrange text-[18px] hover:text-charmHover border-b-[1px] border-charmOrange hover:border-charmHover mb-0"
                                    onClick={() => setExpandedVendor(true)}
                                >
                                    Expand
                                </button>
                            ) : (
                                <button className="w-fit flex flex-row items-center justify-center font-proximanova text-charmOrange text-[18px] hover:text-charmHover border-b-[1px] border-charmOrange hover:border-charmHover mb-0"
                                    onClick={() => setExpandedVendor(false)}
                                >
                                    Collapse
                                </button>
                            )}
                    </div>
                </div>
            </div>

            {loading ? (
                <div className="w-full h-fit flex items-center justify-center">
                    {error ? (
                        <div className="w-full py-[16px] flex items-center justify-center">
                            <p className="text-[18px] text-red font-proximanova font-[400] mb-0">Error updating vendor, please refresh to make sure you are logged in and try again.</p>
                        </div>
                    ) : (
                        <div className="w-full py-[16px] flex items-center justify-center">
                            <span
                                className="spinner-border spinner-border-sm mr-2"
                                role="status"
                                aria-hidden="true"
                            ></span>
                        </div>
                    )}
                </div>
            ) : confirmation ? (
                <div className="w-full h-full flex flex-col overflow-y-auto pb-[16px] px-[16px]">
                    {save ? (
                        <p className="mt-[16px] text-[18px] text-[#fd5764] font-proximanova font-[400] mb-0">Are you sure you want to save these changes?</p>
                    ) : cancel ? (
                        <p className="mt-[16px] text-[18px] text-[#fd5764] font-proximanova font-[400] mb-0">Are you sure you want to discard these changes?</p>
                    ) : ""}

                    <div className="w-full mt-[16px] flex flex-col gap-[8px]">
                        {Object.keys(changedFields).map((key) => (
                            <div className="flex flex-col border-[1px] border-[#999999] p-[8px]" key={key}>
                                <p className="w-full text-[18px] font-proximanova mb-0">{vendorFieldsMapping[key]}: </p>
                                <p className="w-full text-[18px] font-proximanova mb-0">{vendor[key]}</p>
                                <div className="w-full flex flex-row">
                                    <p className="ml-[16px] text-left text-[14px] text-[#999999] font-proximanova mb-0">▼</p>
                                </div>
                                <p className="w-full text-[18px] font-proximanova mb-0">{editedVendor[key]}</p>
                            </div>
                        ))}
                    </div>

                    {save ? (
                        <div className="mt-[16px] flex flex-row items-center justify-center gap-4">
                            <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#76da24] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full"
                                onClick={() => {
                                    handleConfirm();
                                }}>Save Changes</button>

                            <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#fd5764] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full"
                                onClick={() => {
                                    handleDiscard();
                                }}>Cancel</button>
                        </div>
                    ) : cancel ? (
                        <div className="mt-[16px] flex flex-row items-center justify-center gap-4">
                            <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#76da24] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full"
                                onClick={() => {
                                    handleDiscard();
                                }}>Discard Changes</button>

                            <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#fd5764] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full"
                                onClick={() => {
                                    setConfirmation(false);
                                    setCancel(false);
                                    setEditing(true);
                                }}>Do Not Discard Changes</button>
                        </div>
                    ) : ""}
                </div>

            ) : (
                expandedVendor &&
                <div className="w-full h-full mt-[16px] px-[16px] flex flex-col overflow-y-auto pb-[16px]">
                    <div className={`w-full flex flex-row justify-end ${editing ? "" : "gap-4"}`}>
                        {
                            !editing && (
                                <div className="flex flex-row gap-4">
                                    <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#76da24] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full" onClick={() => {
                                        handleChangeVendorApprovalStatus("APPROVED");
                                    }}>Approve</button>
                                    <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#fd5764] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full" onClick={() => {
                                        handleChangeVendorApprovalStatus("REJECTED");
                                    }}>Reject</button>
                                </div>
                            )
                        }
                        {
                            editing ? (
                                <div className="flex flex-row gap-4" >
                                    <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#76da24] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full" onClick={() => {
                                        handleSave();
                                    }}>Save</button>
                                    <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#fd5764] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full" onClick={() => {
                                        handleCancel();
                                    }}>Cancel</button>
                                </div>
                            ) : (
                                <div className="flex flex-row gap-4">
                                    <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-link hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full" onClick={() => setEditing(true)}>Edit</button>
                                </div>
                            )
                        }
                    </div>
                    {selectedVendor && (
                        <div className="mt-[4px] w-full flex flex-col">
                            <h3 className="w-full text-[20px] font-proximanova font-[600] text-[#505050] mb-0">Vendor Information</h3>
                            <div className="w-full flex flex-col lg:flex-row lg:gap-[12px]">
                                <div className="w-full lg:w-1/3 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Vendor Name</label>
                                    {editing ? (
                                        <input
                                            type="text"
                                            className="w-full p-1 bg-white font-proximanova text-[18px] focus:border-charmOrange focus:outline-none border-[1px]"
                                            value={editedVendor.company_name}
                                            onChange={(e) => {
                                                setEditedVendor({ ...editedVendor, company_name: e.target.value });
                                            }}
                                            disabled={!editing}
                                        />
                                    ) : (
                                        <p className="w-full text-[18px] font-proximanova mb-0">
                                            {vendor.company_name}
                                        </p>
                                    )}
                                </div>

                                <div className="w-full lg:w-1/3 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Vendor Address</label>
                                    {editing ? (
                                        <input
                                            className="w-full p-1 bg-white font-proximanova text-[18px] focus:border-charmOrange focus:outline-none border-[1px]"
                                            value={editedVendor.address}
                                            onChange={(e) => {
                                                setEditedVendor({ ...editedVendor, address: e.target.value });
                                            }}
                                            disabled={!editing}
                                        />
                                    ) : (
                                        <p className="w-full text-[18px] font-proximanova mb-0">
                                            {vendor.address}
                                        </p>
                                    )}
                                </div>

                                <div className="w-full lg:w-1/3 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Vendor Website</label>
                                    {editing ? (
                                        <input
                                            className="w-full p-1 bg-white font-proximanova text-[18px] focus:border-charmOrange focus:outline-none border-[1px]"
                                            value={editedVendor.website}
                                            onChange={(e) => {
                                                setEditedVendor({ ...editedVendor, website: e.target.value });
                                            }}
                                            disabled={!editing}
                                        />
                                    ) : (
                                        <p className="w-full text-[18px] font-proximanova mb-0">
                                            {vendor.website}
                                        </p>
                                    )}
                                </div>
                            </div>

                            <label className="mt-[8px] w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-1 ">Vendor Description</label>
                            {editing ? (
                                <textarea
                                    className={`w-full h-48 block p-1 bg-white font-proximanova text-[18px] ${editing ? 'focus:border-charmOrange focus:outline-none border-[1px]' : 'border-[1px] border-white'}`}
                                    value={editedVendor.vendor_bio}
                                    onChange={(e) => {
                                        setEditedVendor({ ...editedVendor, vendor_bio: e.target.value });
                                    }}
                                    disabled={!editing}
                                />
                            ) : (
                                <p className="w-full text-[18px] font-proximanova mb-0">
                                    {vendor.vendor_bio}
                                </p>
                            )}

                            <div className="mt-[8px] w-full flex flex-col lg:flex-row lg:gap-[12px]">
                                <div className="w-full lg:w-1/3 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Year Founded</label>
                                    {editing ? (
                                        <input
                                            className="w-full p-1 bg-white font-proximanova text-[18px] focus:border-charmOrange focus:outline-none border-[1px]"
                                            value={editedVendor.year_founded}
                                            onChange={(e) => {
                                                setEditedVendor({ ...editedVendor, year_founded: e.target.value });
                                            }}
                                            disabled={!editing}
                                        />
                                    ) : (
                                        <p className="w-full text-[18px] font-proximanova mb-0">
                                            {vendor.year_founded}
                                        </p>
                                    )}
                                </div>
                                <div className="w-full lg:w-1/3 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Number of Employees</label>
                                    {editing ? (
                                        <select
                                            value={editedVendor.number_of_employees}
                                            onChange={(e) => setEditedVendor({ ...editedVendor, number_of_employees: e.target.value })}
                                            className="w-full p-1 bg-white font-proximanova text-[18px] focus:border-charmOrange focus:outline-none border-[1px]"
                                            disabled={!editing}
                                        >
                                            <option value="" disabled>Select Number of Employees</option>
                                            <option value="0-50">0-50</option>
                                            <option value="51-100">51-100</option>
                                            <option value="100-500">100-500</option>
                                            <option value="500+">500+</option>
                                        </select>
                                    ) : (
                                        <p className="w-full text-[18px] font-proximanova mb-0">
                                            {vendor.number_of_employees}
                                        </p>
                                    )}
                                </div>
                                <div className="w-full lg:w-1/3 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Revenue</label>
                                    {editing ? (
                                        <select
                                            value={editedVendor.revenue}
                                            onChange={(e) => setEditedVendor({ ...editedVendor, revenue: e.target.value })}
                                            className="w-full p-1 bg-white font-proximanova text-[18px] focus:border-charmOrange focus:outline-none border-[1px]"
                                            disabled={!editing}
                                        >
                                            <option value="">Select Revenue Range</option>
                                            <option value="0-149999">$0 - $149,999</option>
                                            <option value="150000-299999">$150,000 - $299,999</option>
                                            <option value="300000-449999">$300,000 - $449,999</option>
                                            <option value="450000-599999">$450,000 - $599,999</option>
                                            <option value="600000-749999">$600,000 - $749,999</option>
                                            <option value="750000-899999">$750,000 - $899,999</option>
                                            <option value="900000-1049999">$900,000 - $1,049,999</option>
                                            <option value="1050000-1199999">$1,050,000 - $1,199,999</option>
                                            <option value="1200000-1349999">$1,200,000 - $1,349,999</option>
                                            <option value="1350000-1499999">$1,350,000 - $1,499,999</option>
                                            <option value="1500000+">$1,500,000+</option>
                                        </select>
                                    ) : (
                                        <p className="w-full text-[18px] font-proximanova mb-0">
                                            {vendor.revenue}
                                        </p>
                                    )}
                                </div>
                            </div>
                            <label className="mt-[8px] w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Service Specialties</label>
                            {editing ? (
                                <input
                                    className="w-full p-1 bg-white font-proximanova text-[18px] focus:border-charmOrange focus:outline-none border-[1px]"
                                    value={editedVendor.service_specialties}
                                    onChange={(e) => setEditedVendor({ ...editedVendor, service_specialties: e.target.value })}
                                    disabled={!editing}
                                />
                            ) : (
                                <p className="w-full text-[18px] font-proximanova mb-0">
                                    {vendor.service_specialties}
                                </p>
                            )}
                            <label className="mt-[8px] w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Service Description</label>
                            {editing ? (
                                <input
                                    className="w-full p-1 bg-white font-proximanova text-[18px] focus:border-charmOrange focus:outline-none border-[1px]"
                                    value={editedVendor.service_description}
                                    onChange={(e) => setEditedVendor({ ...editedVendor, service_description: e.target.value })}
                                    disabled={!editing}
                                />
                            ) : (
                                <p className="w-full text-[18px] font-proximanova mb-0">
                                    {vendor.service_description}
                                </p>
                            )}
                            <label className="mt-[8px] w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Goal</label>
                            {editing ? (
                                <textarea
                                    className={`w-full h-48 block p-1 bg-white font-proximanova text-[18px] ${editing ? 'focus:border-charmOrange focus:outline-none border-[1px]' : 'border-[1px] border-white'}`}
                                    value={editedVendor.serve_plan}
                                    onChange={(e) => setEditedVendor({ ...editedVendor, serve_plan: e.target.value })}
                                    disabled={!editing}
                                />
                            ) : (
                                <p className="w-full text-[18px] font-proximanova mb-0">
                                    {vendor.serve_plan}
                                </p>
                            )}
                            <div className="mt-[8px] w-full flex flex-col lg:flex-row lg:gap-[12px]">

                                <div className="w-full lg:w-1/2 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">CHIC</label>
                                    {editing ? (
                                        <select
                                            value={editedVendor.is_chic_participant === null ? false : editedVendor.is_chic_participant}
                                            onChange={(e) => setEditedVendor({ ...editedVendor, is_chic_participant: e.target.value === 'true' })}
                                            className={`w-full p-2 bg-white font-proximanova text-[18px] ${editing ? 'focus:border-charmOrange focus:outline-none border-[1px]' : 'border-[1px] border-white'}`}
                                            disabled={!editing}
                                        >
                                            <option value={true}>IS CharmHealth Innovation Challenge Participant</option>
                                            <option value={false}>IS NOT CharmHealth Innovation Challenge Participant</option>
                                        </select>
                                    ) : (
                                        <p className="w-full text-[18px] font-proximanova mb-0">
                                            {vendor.is_chic_participant ? "IS CharmHealth Innovation Challenge Participant" : "IS NOT CharmHealth Innovation Challenge Participant"}
                                        </p>
                                    )}
                                </div>

                                <div className="w-full lg:w-1/2 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">API Interest</label>
                                    {editing ? (
                                        <select
                                            value={editedVendor.has_api_interest === null ? false : editedVendor.has_api_interest}
                                            onChange={(e) => setEditedVendor({ ...editedVendor, has_api_interest: e.target.value })}
                                            className={`w-full p-2 bg-white font-proximanova text-[18px] ${editing ? 'focus:border-charmOrange focus:outline-none border-[1px]' : 'border-[1px] border-white'}`}
                                            disabled={!editing}
                                        >
                                            <option value={true}>IS Interested in APIs</option>
                                            <option value={false}>IS NOT Interested in APIs</option>
                                        </select>
                                    ) : (
                                        <p className="w-full text-[18px] font-proximanova mb-0">
                                            {vendor.has_api_interest ? "IS Interested in APIs" : "IS NOT Interested in APIs"}
                                        </p>
                                    )}
                                </div>
                            </div>

                            <div className="mt-[8px] w-full flex flex-col lg:flex-row lg:gap-[12px]">
                                <div className="w-full lg:w-1/2 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Title</label>
                                    {editing ? (
                                        <input
                                            className="w-full p-1 bg-white font-proximanova text-[18px] focus:border-charmOrange focus:outline-none border-[1px]"
                                            value={editedVendor.title}
                                            onChange={(e) => setEditedVendor({ ...editedVendor, title: e.target.value })}
                                            disabled={!editing}
                                        />
                                    ) : (
                                        <p className="w-full text-[18px] font-proximanova mb-0">
                                            {vendor.title}
                                        </p>
                                    )}
                                </div>
                                <div className="w-full lg:w-1/2 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Contact Name</label>
                                    {editing ? (
                                        <input
                                            className="w-full p-1 bg-white font-proximanova text-[18px] focus:border-charmOrange focus:outline-none border-[1px]"
                                            value={editedVendor.contact_name}
                                            onChange={(e) => setEditedVendor({ ...editedVendor, contact_name: e.target.value })}
                                            disabled={!editing}
                                        />
                                    ) : (
                                        <p className="w-full text-[18px] font-proximanova mb-0">
                                            {vendor.contact_name}
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div className="mt-[8px] w-full flex flex-col lg:flex-row lg:gap-[12px]">
                                <div className="w-full lg:w-1/2 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Contact Email</label>
                                    <p className="w-full text-[18px] font-proximanova mb-0">
                                        {editedVendor.contact_email}
                                    </p>
                                </div>
                                <div className="w-full lg:w-1/2 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Contact Phone</label>
                                    {editing ? (
                                        <input
                                            className="w-full p-1 bg-white font-proximanova text-[18px] focus:border-charmOrange focus:outline-none border-[1px]"
                                            value={editedVendor.contact_phone_number}
                                            onChange={(e) => setEditedVendor({ ...editedVendor, contact_phone_number: e.target.value })}
                                            disabled={!editing}
                                        />
                                    ) : (
                                        <p className="w-full text-[18px] font-proximanova mb-0">
                                            {vendor.contact_phone_number}
                                        </p>
                                    )}
                                </div>
                            </div>

                            <div className="mt-[8px] w-full flex flex-col lg:flex-row lg:gap-[12px]">
                                <div className="w-full lg:w-1/3 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Last Updated</label>
                                    <p className="w-full text-[18px] font-proximanova mb-0">
                                        {new Date(vendor.updated_at).toLocaleString()}

                                    </p>
                                </div>
                                <div className="w-full lg:w-1/3 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Date Approved</label>
                                    <p className="w-full text-[18px] font-proximanova mb-0">
                                        {new Date(vendor.date_approved).toLocaleString()}
                                    </p>
                                </div>

                                <div className="w-full lg:w-1/3 flex flex-col">
                                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Date Registered</label>
                                    <p className="w-full text-[18px] font-proximanova mb-0">
                                        {new Date(vendor.date_registered).toLocaleString()}
                                    </p>
                                </div>
                            </div>
                        </div>
                    )
                    }
                    <h3 className="mt-[8px] w-full text-[20px] font-proximanova font-[600] text-[#505050] mb-0">{selectedVendor.company_name}'s Products</h3>

                    {vendorProducts && vendorProducts.length > 0 ?
                        <div className="w-full flex flex-col">
                            <div className="hidden lg:flex w-full flex-row">
                                <p className="lg:w-full font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Product Name</p>
                                <p className="lg:w-1/5 font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Status</p>
                                <p className="min-w-[108px] font-proximanova font-[600] text-[18px] text-[#505050] mb-0">Actions</p>
                            </div>
                            {vendorProducts.map((product) => {
                                return (
                                    <div key={product.id} className="w-full flex flex-row">
                                        <p className="w-full text-[18px] font-proximanova mb-0">{product.name}</p>
                                        <p className="w-1/5 text-start text-[18px] font-proximanova mb-0">{product.is_published ? "Published" : "Unpublished"}</p>
                                        <div className="min-w-[108px] flex justify-start">
                                            <button
                                                className="w-fit flex flex-row items-center justify-center font-proximanova text-charmOrange text-[18px] hover:text-charmHover border-b-[1px] border-charmOrange hover:border-charmHover mb-0"
                                                onClick={() => {
                                                    navigate(`/admins/profile/products/${product.id}`);
                                                    window.location.reload(); // Refresh the page
                                                }}
                                            >
                                                View Product
                                            </button>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        :
                        <div className="w-full flex flex-col">
                            <p className="w-full text-[18px] font-proximanova mb-0">No products available for this</p>
                        </div>
                    }

                    <div className={`mt-[16px] w-full flex flex-row justify-end ${editing ? "" : "gap-4"}`}>
                        {
                            !editing && (
                                <div className="flex flex-row gap-4">
                                    <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#76da24] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full" onClick={() => {
                                        handleChangeVendorApprovalStatus("APPROVED");
                                    }}>Approve</button>
                                    <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#fd5764] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full" onClick={() => {
                                        handleChangeVendorApprovalStatus("REJECTED");
                                    }}>Reject</button>
                                </div>
                            )
                        }
                        {
                            editing ? (
                                <div className="flex flex-row gap-4" >
                                    <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#76da24] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full" onClick={() => {
                                        handleSave();
                                    }}>Save</button>
                                    <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#fd5764] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full" onClick={() => {
                                        handleCancel();
                                    }}>Cancel</button>
                                </div>
                            ) : (
                                <div className="flex flex-row gap-4">
                                    <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-link hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full" onClick={() => setEditing(true)}>Edit</button>
                                </div>
                            )
                        }
                    </div>
                </div >
            )}
        </div>
    );
}

export default VendorModal;